<app-small-tuile
  type="icon"
  icon="fa-kit fa-picto-injection-ph"
  [title]="'P0003606.dashboard.ph' | translate"
  [content]="
    buttonMode[this.actionStack!.getValue('iphCActivationRegulation')].icon!
  "
  [color]="
    buttonMode[this.actionStack!.getValue('iphCActivationRegulation')].color!
  "
  [status]="
    buttons[this.actionStack!.getValue('iphSEtatPompe')].title! | translate
  "
  [statusMode]="buttons[this.actionStack!.getValue('iphSEtatPompe')].status!"
  (onPress)="this.openProductModal()"
>
</app-small-tuile>
